import styled from "styled-components";
import { MdFileDownload } from "react-icons/md";
import { BsArrowRepeat } from "react-icons/bs";

const BookingsSuper = () => {
  const data = [
    {
      id: "B003",
      partnerType: "Organization",
      spot: "Museum Visit",
      name: "Charlie Brown",
      phone: "555-0103",
      bookingDateTime: "Jun 10, 2024, 4:30 PM",
      visitDate: "Jun 10, 2024",
      payment: "Cash",
      qty: 4,
      ticketStatus: "Used",
      bookingStatus: "Confirmed",
      amount: "25.00",
      ticketType: "Counter",
    },
    {
      id: "B006",
      partnerType: "Organization",
      spot: "Evening Ghost Tour",
      name: "Fiona Gallagher",
      phone: "555-0106",
      bookingDateTime: "Jul 25, 2024, 11:30 PM",
      visitDate: "Jul 25, 2024",
      payment: "Card",
      qty: 1,
      ticketStatus: "Active",
      bookingStatus: "Confirmed",
      amount: "30.00",
      ticketType: "Online",
    },
    {
      id: "B009",
      partnerType: "Business",
      spot: "Pizza Order",
      name: "Hermione Granger",
      phone: "555-0109",
      bookingDateTime: "Jul 29, 2024, 5:30 PM",
      visitDate: "Jul 29, 2024",
      payment: "UPI",
      qty: 2,
      ticketStatus: "Active",
      bookingStatus: "Confirmed",
      amount: "35.00",
      ticketType: "Online",
    },
    {
      id: "B010",
      partnerType: "Business",
      spot: "Coffee & Pastry",
      name: "Ron Weasley",
      phone: "555-0104",
      bookingDateTime: "Jul 30, 2024, 2:45 PM",
      visitDate: "Jul 30, 2024",
      payment: "Card",
      qty: 1,
      ticketStatus: "Expired",
      bookingStatus: "Confirmed",
      amount: "12.50",
      ticketType: "Counter",
    },
    {
      id: "B011",
      partnerType: "Business",
      spot: "Snack Combo",
      name: "Draco Malfoy",
      phone: "555-0111",
      bookingDateTime: "Jul 31, 2024, 10:15 PM",
      visitDate: "Jul 31, 2024",
      payment: "Cash",
      qty: 1,
      ticketStatus: "Active",
      bookingStatus: "Pending",
      amount: "8.75",
      ticketType: "Online",
    },
  ];

  return (
    <Wrapper>
      <div className="container py-5">
        <div className="card border-0 shadow-sm p-4">
          <div className="container mt-4">
            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap">
              <div>
                <h4 className="text-dark mb-1 d-flex align-items-center">Booking Oversight</h4>
                <p className="text-muted mb-0">
                  Over all booking activities across different partners
                </p>
              </div>
              <div className="mt-2 mt-md-0">
                <button className="btn btn-primary d-flex align-items-center">
                  <MdFileDownload className="me-2" size={20} />
                  Export  Data
                </button>
              </div>
            </div>
                
            <div className="container my-4 p-0">
              <div className="d-flex align-items-center flex-nowrap gap-2 mb-3 filter-box">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search ID, Customer, Service"
                />
                <select className="form-select">
                  <option>All Partners</option>
                </select>
                <select className="form-select">
                  <option>All Time</option>
                </select>
                <select className="form-select">
                  <option>All Statuses</option>
                </select>
                <button className="btn btn-outline-secondary d-flex align-items-center gap-1">
                  <BsArrowRepeat size={16} />
                  Clear Filters
                </button>
              </div>

              <table className="table table-bordered align-middle">
                <thead>
                  <tr>
                    <th>Booking ID</th>
                    <th>Partner Type</th>
                    <th>Spot Name</th>
                    <th>Visitor Details</th>
                    <th>Booking Date & Time</th>
                    <th>Visit Date</th>
                    <th>Ticket Type</th>
                    <th>Qty</th>
                    <th>Ticket Status</th>
                    <th>Booking Status</th>
                    <th>Amount</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((d) => (
                    <tr key={d.id}>
                      <td>{d.id}</td>
                      <td>
                        <span
                          className={`badge badge-pill ${
                            d.partnerType === "Organization" ? "bg-org" : "bg-biz"
                          }`}
                        >
                          {d.partnerType}
                        </span>
                      </td>
                      <td>{d.spot}</td>
                      <td>
                        {d.name}
                        <br />
                        <small>{d.phone}</small>
                      </td>
                      <td>{d.bookingDateTime}</td>
                      <td>{d.visitDate}</td>
                      <td>
                        <span
                          className={`badge bg-${
                            d.ticketType === "Counter" ? "warning" : "info"
                          } text-dark`}
                        >
                          {d.ticketType}
                        </span>
                      </td>
                      <td>{d.qty}</td>
                      <td>
                        <span
                          className={`badge badge-pill status-${d.ticketStatus.toLowerCase()}`}
                        >
                          {d.ticketStatus}
                        </span>
                      </td>
                      <td>
                        <span className="badge badge-pill bg-success-opacity text-success">
                          {d.bookingStatus}
                        </span>
                      </td>
                      <td>{d.amount} USD</td>
                      <td className="text-center">
                        <span className="action-icon">...</span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};

export default BookingsSuper;

const Wrapper = styled.div`
  .bg-success-opacity {
    background-color: #d4edda;
  }

  .badge-pill {
    border-radius: 20px;
    padding: 4px 12px;
    font-size: 12px;
  }

  .bg-org {
    background-color: #e0f4ff;
    color: #1e90ff;
  }

  .bg-biz {
    background-color: #e8e6ff;
    color: #6f42c1;
  }

  .table thead th {
    background-color: #f8f9fa;
  }

  .status-used {
    background-color: #fff3cd;
    color: #856404;
  }

  .status-active {
    background-color: #d4edda;
    color: #198754;
  }

  .status-expired {
    background-color: #f8d7da;
    color: #721c24;
  }

  .status-pending {
    background-color: #fff3cd;
    color: #856404;
  }

  .action-icon {
    cursor: pointer;
  }

  .filter-box input,
  .filter-box select {
    width: 169px;
  }
span.badge.bg-warning.text-dark {
    background-color: rgba(13, 202, 240, 0.15) !important;
    color: #0dcaf0 !important;
}
span.badge.bg-info.text-dark {
    background-color: rgba(13, 202, 240, 0.15) !important;
    color: #19899f !important;
}

`;
